import { cancelledUnpaid } from '@/constant'

export const getLessonStatusOptions = ({
  conferenceType,
  directionTariff,
  hasPaidCancel,
  canRescheduleCurrentReport,
  isOpen,
  isClosedCustomizable,
  hasOpenLessonAttendees = true,
}) => {
  if (isClosedCustomizable) {
    return [
      { label: 'Проведено', value: '5' },
      { label: 'Перенесено занятие', value: 'reschedule' },
      { label: 'Отменено', value: '11' },
    ]
  }

  if (isOpen && !hasOpenLessonAttendees) {
    return [{ label: 'Отменено (педагог)', value: '11' }]
  }

  const nextOptions = [{ label: 'Проведено', value: '5' }]
  const isGroupPerLesson = directionTariff === 'group_per_lesson'

  if (canRescheduleCurrentReport) {
    nextOptions.push({ label: 'Перенесено занятие', value: 'reschedule' })
  }

  nextOptions.push({ label: 'Отменено (педагог)', value: '11' })

  if (isGroupPerLesson) {
    nextOptions.push({ label: 'Отменено (ученик)', value: '10' })
    nextOptions.push({ label: 'Платная отмена', value: '12' })
    return nextOptions
  }

  if (conferenceType === 'group') {
    nextOptions.push({ label: 'Отменено (ученик)', value: '10' })
    return nextOptions
  }

  if (conferenceType !== 'group') {
    nextOptions.push({ label: 'Отменено (ученик)', value: '10' })
    if (conferenceType !== 'introduction') {
      if (!isOpen) {
        nextOptions.push({
          label: 'Отменено (не оплачено)',
          value: String(cancelledUnpaid),
        })
      }

      if (isOpen || Number(hasPaidCancel) === 1) {
        nextOptions.push({ label: 'Платная отмена', value: '12' })
      }
    }
  }

  return nextOptions
}

export const getLessonStatusDescription = (
  status,
  isClosedCustomizable = false,
) => {
  switch (status) {
    case '10':
      return 'Опишите причину отмены занятия (отмена учеником)'
    case '11':
      return isClosedCustomizable
        ? 'Опишите причину отмены занятия'
        : 'Опишите причину отмены занятия (отмена педагогом)'
    case '12':
      return 'Опишите причину отмены занятия (платная отмена)'
    case 'reschedule':
      return 'Напишите комментарий (перенос занятия)'
    default:
      return 'Напишите комментарий'
  }
}

export const isClosedCustomizableLesson = (report) =>
  report?.conference_type === 'customizable' && String(report?.isOpen) === '0'

export const isLessonStatusCommentRequired = (status, conferenceType) =>
  status !== '5' || conferenceType === 'introduction'

export const shouldSaveLessonSalary = (
  canEditSalary,
  conferenceType,
  salaryChanged,
) => {
  void conferenceType
  return canEditSalary && salaryChanged
}
